"use client";
import { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import Script from 'next/script';
import { useStore, useShare, usePlatform, useSentry, APP_ACTION_TYPES } from '@/hooks';
import { AppContext } from '../context';
import Sensor from '../utils/sensor';
import i18nData from '../utils/i18n';
import { setBaseSize } from '../utils';
import '../styles/common.scss';
import '../styles/mobile.scss';

export default function RootLayout({ children }) {
  const [store, dispatch] = useStore();
  useShare(store);
  usePlatform(dispatch);

  useSentry();

  useEffect(() => {
    setBaseSize();
    Sensor.init().then(() => {
      dispatch({
        type: APP_ACTION_TYPES.IS_SENSOR_INIT,
        payload: { isSensorInit: true },
      });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <IntlProvider locale={i18nData?.locale || 'en'} messages={i18nData?.messages || {}}>
      <AppContext.Provider value={{ store, dispatch }}>
        <html lang="en">
          <meta
            name='viewport'
            content='width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
          />
          <body>
            <div id='__next'>{children}</div>
            <Script strategy='afterInteractive' id='jweixin-sdk'>
              {`!function(){var e=window.navigator.userAgent;if(e&&/(micromessenger|miniprogram)/i.test(e.toLowerCase())){var t=document.createElement("script"),n=document.getElementsByTagName("script")[0];t.async=1,t.src="//res.wx.qq.com/open/js/jweixin-1.6.0.js",n.parentNode.insertBefore(t,n)}}()`}
            </Script>

          </body>
        </html>
      </AppContext.Provider>
    </IntlProvider>
  )
}
